import {includesBy} from './includesBy';

export function difference(arr1: any[], arr2: any[], key: string): any[] {
  const diffLeft = arr1.filter(x => !includesBy(x, arr2, key));
  // const diffRight = arr1.filter(x => !includesBy(x, arr1, key));

  return diffLeft;
}
